import { useCallback } from 'react'

import { MenuV2 } from '@circlefin/components'
import { useModal } from '@circlefin/modal-router'
import { routes } from '@services/sections/modal/routes'
import { UserStatusType, type User } from '@shared/graphql'
import classNames from 'classnames'
import useTranslation from 'next-translate/useTranslation'

export interface UsersTableMenuProps {
  /**
   * The user object for the row to represent.
   */
  user: User
}

export const UsersTableMenu: React.FC<UsersTableMenuProps> = ({ user }) => {
  const { t } = useTranslation('settings')
  const { t: tCommon } = useTranslation('common')

  const modal = useModal()

  const handleRemoveUser = useCallback(
    () =>
      modal.router.push({
        pathname: routes.account.users.remove,
        query: {
          user,
        },
      }),
    [modal.router, user],
  )

  const isAuthorizedRep = user.isAuthorizedRepresentative === true

  if (user.status !== UserStatusType.ACTIVE || user.current) {
    return null
  }

  return (
    <MenuV2 disabled={isAuthorizedRep}>
      <MenuV2.IconButton
        className={classNames({
          'pointer-events-auto': isAuthorizedRep,
          'hover:bg-transparent': isAuthorizedRep,
        })}
        label={
          isAuthorizedRep ? t('personalInfo.disabledMenu') : tCommon('options')
        }
        variant="secondary"
      />
      <MenuV2.Options>
        <MenuV2.Item
          item={{ label: t('manageUsers.removeUserLabel'), value: 'remove' }}
          onClick={handleRemoveUser}
        />
      </MenuV2.Options>
    </MenuV2>
  )
}
